import React from 'react'
import { Link } from 'react-router-dom'
import { Sparkles, ArrowRight } from 'lucide-react'
import styles from './SMSetupState.module.css'

// Distinguishes "0 results because nothing is configured yet" from
// "0 results because no one has a birthday today" — has_occasion_data
// tells us which one we're looking at, across every sm_* endpoint that
// returns it, so we never show a cheerful "all done!" empty state for
// a store that hasn't entered a single birthday.
const SMSetupState = ({
    message,
    title = "Let's set up Special Moments",
    ctaLabel = 'Go to Clients',
    ctaHref = '/manage/clients',
}) => (
    <div className={styles.wrap}>
        <div className={styles.iconWrap}>
            <Sparkles size={20} />
        </div>
        <div className={styles.title}>{title}</div>
        <p className={styles.message}>
            {message || "No special moments added yet. Start by adding a client's birthday or anniversary."}
        </p>
        <Link to={ctaHref} className={styles.cta}>
            {ctaLabel} <ArrowRight size={14} />
        </Link>
    </div>
)

export default SMSetupState
